import { createSelector } from 'reselect';

const selectCmsSettings = (state: any) => state.cmsSettings;

export const selectCmsSettingsCurrentItem = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.current);

export const selectCmsSettingsListItems = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.list);


export const selectCmsSettingsItemById = (itemId: any) =>
    createSelector(selectCmsSettingsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCmsSettingsCreatedItem = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.create);

export const selectCmsSettingsQueryItems = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.query);

export const selectCmsSettingsUpdatedItem = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.update);

export const selectCmsSettingsReadItem = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.read);

export const selectCmsSettingsDeletedItem = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.delete);

export const selectCmsSettingsSearchedItems = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.search);

export const selectCmsSettingsItemsCount = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.count);

export const selectCmsSettingsItemsFilter = createSelector([selectCmsSettings], (cmsSettings) => cmsSettings.filter);